import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ITimezonePromiseLookupService } from "../ITimezonePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TimezoneLookupService } from "../../../index";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TimezoneReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.TimeZoneImpl>
  implements ITimezonePromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.TimeZoneImpl, "TimeZoneImpl");
  }

  getTimezone(id: string): Promise<CubiqTS.TimeZoneImpl> {
    let request = new UiArguments("getTimezone");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAllTimezones(): Promise<Array<CubiqTS.TimeZoneImpl>> {
    let request = new UiArguments("getAllTimezones");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }
}
